import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminpartner',
  templateUrl: './adminpartner.component.html',
  styleUrls: ['./adminpartner.component.css']
})
export class AdminpartnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
